<app-dialog-heading [heading]="'Activity Results'"></app-dialog-heading>

<label class="mat-primary-color" style="margin-left: 2vw; font-size: small;">Hint: click on a row to expand more information</label>

<div class="dialog-content" style="max-height: 80vh">
  <table mat-table multiTemplateDataRows [dataSource]="dataSource"
         matSort (matSortChange)="sortData($event)">

    <ng-container [matColumnDef]="tableColumns.ActivityStartDate">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Date</th>
      <td *matCellDef="let row" mat-cell>{{getDateRangeDisplay(row)}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.Type">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Type</th>
      <td *matCellDef="let row" mat-cell>{{row[tableColumns.Type]}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.TariffCode">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Tariff</th>
      <td *matCellDef="let row" mat-cell>
        {{getTariffDisplay(row)}}
        @if (isMixtureActivity(row)) {
          <span class="mixture-chip" [matTooltip]="row.mixtureType">
            {{getMixtureChipLabel(row)}}
          </span>
        }
      </td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.DiagnosisCode">
      <th *matHeaderCellDef mat-header-cell>Diagnosis</th>
      <td *matCellDef="let row" mat-cell>{{row[tableColumns.DiagnosisCode]}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.Benefit">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Benefit</th>
      <td *matCellDef="let row" mat-cell>{{row.benefitCode}}: {{row.benefitName | slice:0:25}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.RequestedQuantity">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Rqt Qty (Apr Qty)</th>
      <td *matCellDef="let row" mat-cell>
        {{row.requestedQuantity}} <span class="approved-qty">({{row.approvedQuantity}})</span>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.AmountClaimed">
      <th *matHeaderCellDef mat-header-cell>Claimed Amt</th>
      <td *matCellDef="let row" mat-cell>{{ (row[tableColumns.AmountClaimed] ?? 0) | number:'1.2-2'}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.AmountBenefit">
      <th *matHeaderCellDef mat-header-cell>Benefit Amt</th>
      <td *matCellDef="let row" mat-cell>{{ (row[tableColumns.AmountBenefit] ?? 0) | number:'1.2-2'}}</td>
    </ng-container>

   <ng-container [matColumnDef]="tableColumns.AmountCoPayment">
      <th *matHeaderCellDef mat-header-cell>Co-pay Amount</th>
      <td *matCellDef="let row" mat-cell>{{ (row[tableColumns.AmountCoPayment] ?? 0) | number:'1.2-2'}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.AmountRejected">
      <th *matHeaderCellDef mat-header-cell>Rejected Amt</th>
      <td *matCellDef="let row" mat-cell>{{ (row[tableColumns.AmountRejected] ?? 0) | number:'1.2-2'}}</td>
    </ng-container>

    <ng-container [matColumnDef]="tableColumns.AdjudicationStatus">
      <th *matHeaderCellDef mat-header-cell mat-sort-header></th>
      <td *matCellDef="let row" mat-cell>
        @if (row.adjudicationStatus?.name) {
          <greydom-status-indicator
            [fillColor]="getStatusColor(row.adjudicationStatus.name)"
            [matTooltip]="row.adjudicationStatus.name">
          </greydom-status-indicator>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="displayedColumns.length">
        <div class="row-detail-container" [@detailExpand]="row == expandedRow ? 'expanded' : 'collapsed'">
          <b>Case: </b>{{row.caseName}}<br>
          <b>Tariff Description: </b>{{row.tariffDescription}}<br>
          <b>Deductible amount: </b>R{{ (row.amountDeductible ?? 0) | number:'1.2-2' }}<br>
          <b>Missed Payments: </b>{{row.missedPayments}}<br>
          <b>Benefit Family: </b>{{row.benefitFamily}}<br>
          <b>{{encounterOverrideIndicatorNames.overrideIndicator1 || 'Encounter Override'}}: </b>{{row.encounterOverride1 == 1 ? 'Yes' : 'No'}}<br>
          <b>{{activityOverrideIndicatorNames.overrideIndicator1 || 'Activity Override 1'}}: </b>{{row.activityOverride1 == 1 ? 'Yes' : 'No'}}<br>
          <b>{{activityOverrideIndicatorNames.overrideIndicator2 || 'Activity Override 2'}}: </b>{{row.activityOverride2 == 1 ? 'Yes' : 'No'}}<br>
          <b>{{activityOverrideIndicatorNames.overrideIndicator3 || 'Activity Override 3'}}: </b>{{row.activityOverride3 == 1 ? 'Yes' : 'No'}}<br>
          <b>Matched Activity: </b>{{row.matchedActivity}}<br>
          <b>Matched Transaction: </b>{{row.matchedTransaction}}<br>
          <b>Historical Activity: </b>{{row.historicalActivity}}<br>
          <b>Historical Transaction: </b>{{row.historicalTransaction}}<br>
          <b>Is PMB: </b>{{ row.isPmb == 1 ? 'Yes' : 'No' }}<br>
          <b>Rule Messages: </b><br>
          <table class="m-l-15 dark-grey">
            @for (message of row.ruleMessages; track $index) {
              <tr>
                <td>
                  @if (message.actionCode === 'Reject') {
                    <span class="red-indicator">⬤</span>
                  }
                  @if (message.actionCode === 'Pend' || message.actionCode === 'Warn') {
                    <span class="yellow-indicator">⬤</span>
                  }
                  <b>{{message.actionCode}}</b>
                </td>
                <td>{{formatDateDisplay(message.created)}}</td>
                <td>{{message.overrideIndicator === 1 ? 'Overridden' : 'No Override'}}</td>
                <td><b>{{message.code}}</b>: {{message.description}}</td>
              </tr>
            }
          </table>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
        [class.expanded-row]="expandedRow == row"
        (click)="expandedRow = expandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>

  </table>

  <mat-paginator (page)="pageChanged($event)"
                 [pageIndex]="0" [pageSize]="tableControl.pageSize"
                 [pageSizeOptions]="tableControl.pageSizeOptions"
                 [length]="tableControl.length">
  </mat-paginator>

  <mat-dialog-actions align="center" class="dialog-button-container">
    <button class="dialog-button" mat-raised-button color="primary" (click)="onOkayClick()">Okay</button>
    <button mat-raised-button color="primary"
            [disabled]="!isReportable"
            (click)="onGenerateClick($event)">
      <mat-icon>download</mat-icon>
      Generate Report
     <app-busy-spinner-icon [isBusyCounter]="isBusyCounterInlineSpinner"></app-busy-spinner-icon>
    </button>

   @if ((isClaim && isProviderPortal) && showGenerateRemittanceReportBtn) {
     <button mat-raised-button color="primary"
             [disabled]="!showGenerateRemittanceReportBtn"
             (click)="onGenerateRemittanceClick()">
       <mat-icon>download</mat-icon>
       Generate Remittance
       <app-busy-spinner-icon [isBusyCounter]="isBusyCounterRemittance"></app-busy-spinner-icon>
     </button>
   }
  </mat-dialog-actions>
</div>


